// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReviewImpactProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ReviewImpactProjectQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Region', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Market', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Community', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Subdivision', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Lot', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Structure', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Unit', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
  , projectItemsPage: { __typename?: 'ProjectItemsPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type ReviewProjectImpactChangeEventQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type ReviewProjectImpactChangeEventQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, totalPriceInCents: number, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } } }> } };

export type ReviewProjectScheduleImpactQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  changeEventId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  checkoutConfigId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type ReviewProjectScheduleImpactQuery = { __typename?: 'Query', projectScheduleImpact: { __typename?: 'ProjectScheduleImpact', currentCompletionDate?: Types.Scalars['Date']['input'] | null | undefined, proposedCompletionDate?: Types.Scalars['Date']['input'] | null | undefined, differenceInDays?: number | null | undefined, milestones: Array<{ __typename?: 'MilestoneScheduleImpact', id: string, currentFinishDate?: Types.Scalars['Date']['input'] | null | undefined, proposedFinishDate?: Types.Scalars['Date']['input'] | null | undefined, changeInDays?: number | null | undefined, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string } }> } };

export type ReviewProjectImpact_ScheduleImpactFragment = { __typename?: 'ProjectScheduleImpact', currentCompletionDate?: Types.Scalars['Date']['input'] | null | undefined, proposedCompletionDate?: Types.Scalars['Date']['input'] | null | undefined, differenceInDays?: number | null | undefined, milestones: Array<{ __typename?: 'MilestoneScheduleImpact', id: string, currentFinishDate?: Types.Scalars['Date']['input'] | null | undefined, proposedFinishDate?: Types.Scalars['Date']['input'] | null | undefined, changeInDays?: number | null | undefined, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string } }> };

export type ReviewProjectImpact_MilestoneScheduleImpactFragment = { __typename?: 'MilestoneScheduleImpact', id: string, currentFinishDate?: Types.Scalars['Date']['input'] | null | undefined, proposedFinishDate?: Types.Scalars['Date']['input'] | null | undefined, changeInDays?: number | null | undefined, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string } };

export type ReviewProjectImpact_ProjectCostCodeFragment = { __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } };

export type ReviewProjectImpact_CostCodeFragment = { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } };

export type ReviewProjectImpact_ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, totalPriceInCents: number, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } } }> };

export type ReviewProjectImpact_ChangeEventLineItemFragment = { __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, totalPriceInCents: number, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } } };

export const ReviewProjectImpact_MilestoneScheduleImpactFragmentDoc = gql`
    fragment ReviewProjectImpact_MilestoneScheduleImpact on MilestoneScheduleImpact {
  id
  globalPlanMilestone {
    id
    name
  }
  currentFinishDate
  proposedFinishDate
  changeInDays
}
    `;
export const ReviewProjectImpact_ScheduleImpactFragmentDoc = gql`
    fragment ReviewProjectImpact_ScheduleImpact on ProjectScheduleImpact {
  currentCompletionDate
  proposedCompletionDate
  differenceInDays
  milestones {
    ...ReviewProjectImpact_MilestoneScheduleImpact
  }
}
    ${ReviewProjectImpact_MilestoneScheduleImpactFragmentDoc}`;
export const ReviewProjectImpact_CostCodeFragmentDoc = gql`
    fragment ReviewProjectImpact_CostCode on CostCode {
  id
  displayName
  division {
    id
    name
  }
}
    `;
export const ReviewProjectImpact_ProjectCostCodeFragmentDoc = gql`
    fragment ReviewProjectImpact_ProjectCostCode on ProjectCostCode {
  id
  totalCostInCents
  costCode {
    ...ReviewProjectImpact_CostCode
  }
}
    ${ReviewProjectImpact_CostCodeFragmentDoc}`;
export const ReviewProjectImpact_ChangeEventLineItemFragmentDoc = gql`
    fragment ReviewProjectImpact_ChangeEventLineItem on ChangeEventLineItem {
  id
  totalCostInCents
  totalPriceInCents
  typeDetail {
    code
    name
  }
  item {
    id
    costCode {
      ...ReviewProjectImpact_CostCode
    }
  }
}
    ${ReviewProjectImpact_CostCodeFragmentDoc}`;
export const ReviewProjectImpact_ChangeEventFragmentDoc = gql`
    fragment ReviewProjectImpact_ChangeEvent on ChangeEvent {
  id
  lineItems {
    ...ReviewProjectImpact_ChangeEventLineItem
  }
}
    ${ReviewProjectImpact_ChangeEventLineItemFragmentDoc}`;
export const ReviewImpactProjectDocument = gql`
    query ReviewImpactProject($projectId: ID!) {
  project(id: $projectId) {
    id
    lotType {
      code
      clientNoun
    }
    projectCostCodes {
      ...ReviewProjectImpact_ProjectCostCode
    }
  }
  projectItemsPage(
    filter: {project: [$projectId], isRemovedScope: false}
    page: {offset: 0, limit: 1}
  ) {
    pageInfo {
      totalCount
    }
  }
}
    ${ReviewProjectImpact_ProjectCostCodeFragmentDoc}`;

/**
 * __useReviewImpactProjectQuery__
 *
 * To run a query within a React component, call `useReviewImpactProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewImpactProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewImpactProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useReviewImpactProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables> & ({ variables: ReviewImpactProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>(ReviewImpactProjectDocument, options);
      }
export function useReviewImpactProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>(ReviewImpactProjectDocument, options);
        }
// @ts-ignore
export function useReviewImpactProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>;
export function useReviewImpactProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewImpactProjectQuery | undefined, ReviewImpactProjectQueryVariables>;
export function useReviewImpactProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>(ReviewImpactProjectDocument, options);
        }
export type ReviewImpactProjectQueryHookResult = ReturnType<typeof useReviewImpactProjectQuery>;
export type ReviewImpactProjectLazyQueryHookResult = ReturnType<typeof useReviewImpactProjectLazyQuery>;
export type ReviewImpactProjectSuspenseQueryHookResult = ReturnType<typeof useReviewImpactProjectSuspenseQuery>;
export type ReviewImpactProjectQueryResult = ApolloReactCommon.QueryResult<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>;
export const ReviewProjectImpactChangeEventDocument = gql`
    query ReviewProjectImpactChangeEvent($changeEventId: ID!) {
  changeEvent(id: $changeEventId) {
    ...ReviewProjectImpact_ChangeEvent
  }
}
    ${ReviewProjectImpact_ChangeEventFragmentDoc}`;

/**
 * __useReviewProjectImpactChangeEventQuery__
 *
 * To run a query within a React component, call `useReviewProjectImpactChangeEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewProjectImpactChangeEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewProjectImpactChangeEventQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useReviewProjectImpactChangeEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables> & ({ variables: ReviewProjectImpactChangeEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>(ReviewProjectImpactChangeEventDocument, options);
      }
export function useReviewProjectImpactChangeEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>(ReviewProjectImpactChangeEventDocument, options);
        }
// @ts-ignore
export function useReviewProjectImpactChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>;
export function useReviewProjectImpactChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewProjectImpactChangeEventQuery | undefined, ReviewProjectImpactChangeEventQueryVariables>;
export function useReviewProjectImpactChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>(ReviewProjectImpactChangeEventDocument, options);
        }
export type ReviewProjectImpactChangeEventQueryHookResult = ReturnType<typeof useReviewProjectImpactChangeEventQuery>;
export type ReviewProjectImpactChangeEventLazyQueryHookResult = ReturnType<typeof useReviewProjectImpactChangeEventLazyQuery>;
export type ReviewProjectImpactChangeEventSuspenseQueryHookResult = ReturnType<typeof useReviewProjectImpactChangeEventSuspenseQuery>;
export type ReviewProjectImpactChangeEventQueryResult = ApolloReactCommon.QueryResult<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>;
export const ReviewProjectScheduleImpactDocument = gql`
    query ReviewProjectScheduleImpact($projectId: ID!, $changeEventId: ID, $checkoutConfigId: ID) {
  projectScheduleImpact(
    projectId: $projectId
    changeEventId: $changeEventId
    checkoutConfigId: $checkoutConfigId
  ) {
    ...ReviewProjectImpact_ScheduleImpact
  }
}
    ${ReviewProjectImpact_ScheduleImpactFragmentDoc}`;

/**
 * __useReviewProjectScheduleImpactQuery__
 *
 * To run a query within a React component, call `useReviewProjectScheduleImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewProjectScheduleImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewProjectScheduleImpactQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      changeEventId: // value for 'changeEventId'
 *      checkoutConfigId: // value for 'checkoutConfigId'
 *   },
 * });
 */
export function useReviewProjectScheduleImpactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewProjectScheduleImpactQuery, ReviewProjectScheduleImpactQueryVariables> & ({ variables: ReviewProjectScheduleImpactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewProjectScheduleImpactQuery, ReviewProjectScheduleImpactQueryVariables>(ReviewProjectScheduleImpactDocument, options);
      }
export function useReviewProjectScheduleImpactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewProjectScheduleImpactQuery, ReviewProjectScheduleImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewProjectScheduleImpactQuery, ReviewProjectScheduleImpactQueryVariables>(ReviewProjectScheduleImpactDocument, options);
        }
// @ts-ignore
export function useReviewProjectScheduleImpactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectScheduleImpactQuery, ReviewProjectScheduleImpactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewProjectScheduleImpactQuery, ReviewProjectScheduleImpactQueryVariables>;
export function useReviewProjectScheduleImpactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectScheduleImpactQuery, ReviewProjectScheduleImpactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewProjectScheduleImpactQuery | undefined, ReviewProjectScheduleImpactQueryVariables>;
export function useReviewProjectScheduleImpactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectScheduleImpactQuery, ReviewProjectScheduleImpactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewProjectScheduleImpactQuery, ReviewProjectScheduleImpactQueryVariables>(ReviewProjectScheduleImpactDocument, options);
        }
export type ReviewProjectScheduleImpactQueryHookResult = ReturnType<typeof useReviewProjectScheduleImpactQuery>;
export type ReviewProjectScheduleImpactLazyQueryHookResult = ReturnType<typeof useReviewProjectScheduleImpactLazyQuery>;
export type ReviewProjectScheduleImpactSuspenseQueryHookResult = ReturnType<typeof useReviewProjectScheduleImpactSuspenseQuery>;
export type ReviewProjectScheduleImpactQueryResult = ApolloReactCommon.QueryResult<ReviewProjectScheduleImpactQuery, ReviewProjectScheduleImpactQueryVariables>;